export default __webpack_public_path__ + "b3975f8cbb417c0c7f5020961297388a.svg";